export const ONBOARDING_DESTINATIONS = {
  HOME: 'home',
  PROFILE: 'profile',
  GOALS: 'goals',
  SAFETY: 'safety',
};

export function resolveOnboardingDestination(completedSteps = []) {
  const steps = new Set(completedSteps);

  if (!steps.has('profile')) {
    return ONBOARDING_DESTINATIONS.PROFILE;
  }
  if (!steps.has('goals') || !steps.has('nutrition')) {
    return ONBOARDING_DESTINATIONS.GOALS;
  }
  if (!steps.has('safety')) {
    return ONBOARDING_DESTINATIONS.SAFETY;
  }
  return ONBOARDING_DESTINATIONS.HOME;
}
